import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import {
  Colors,
  ButtonType,
  BfBadge,
  BfAccordion,
  BfButton,
  BfDescriptionList,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'SaddleHardware',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const measurementStore = useMeasurementStore()
const { selectedMeasurement } = storeToRefs(measurementStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BfAccordion), {
    title: _unref(t)('setup.parts.saddle')
  }, {
    "header-right": _withCtx(() => [
      _createVNode(_unref(BfButton), {
        type: _unref(ButtonType).Outlined,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
          _unref(router).push({
            name:
              _unref(router).currentRoute.value.meta.step === 2
                ? 'saddleSelection'
                : 'saddleUpdate',
          })
        ), ["stop"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('common.change')), 1)
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_unref(BfBadge), {
        color: 
          _unref(selectedMeasurement)?.saddle.active !== undefined
            ? _unref(Colors).Success
            : _unref(Colors).Danger
        
      }, null, 8, ["color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BfDescriptionList), {
        label: _unref(t)('setup.saddle.model')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(selectedMeasurement)?.saddle.active
          ? `${_unref(selectedMeasurement)?.saddle.active.SADDLE_BRAND} ${_unref(selectedMeasurement)?.saddle.active.SADDLE_MODEL}`
          : '-'), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(BfDescriptionList), {
        label: _unref(t)('setup.saddle.width')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(selectedMeasurement)?.saddle.active
          ? `${_unref(selectedMeasurement)?.saddle.active.SADDLE_WIDTH} ${_unref(t)('common.unit.mm')}`
          : '-'), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(BfDescriptionList), {
        label: _unref(t)('setup.saddle.shape.index')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(selectedMeasurement)?.saddle.active
          ? _unref(selectedMeasurement)?.saddle.active.SHAPE
          : '-'), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(BfDescriptionList), {
        label: _unref(t)('setup.saddle.anatomical')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(selectedMeasurement)?.saddle.active
          ? _unref(selectedMeasurement)?.saddle.active.ANATOMIC_DESIGN
            ? _unref(t)('common.yes')
            : _unref(t)('common.no')
          : '-'), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})